import moment from 'moment'

const date = (date: string | Date): string => {
	const d = moment(date)
	if (!d.isValid()) {
		return ''
	}
	return d.format('Do MMM YYYY')
}

const time = (date: string | Date): string => {
	const d = moment(date)
	if (!d.isValid()) {
		return ''
	}
	return d.format('h:mm a')
}

const dateTime = (date: string | Date): string => {
	const d = moment(date)
	if (!d.isValid()) {
		return ''
	}
	return d.format('ddd, MMM Do YYYY, h:mm:ss a')
}

const number = (number: number, decimalPlaces: number): string => {
	if (number === 0) {
		return '0'
	} else if (number < 1 && number > -1) {
		return `${number < 0 ? '-' : ''}<1`
	}
	const absNumber = Math.abs(number)
	const sizes = ['', 'k', 'm', 'b']
	const zeroes = Math.log10(absNumber)
	const size = Math.floor(zeroes / 3)
	const num = absNumber / Math.pow(10, size * 3)
	return `${number < 0 ? '-' : ''}${num.toFixed(decimalPlaces)}${sizes[Math.abs(size)]}`
}

const properCase = (str: string): string => {
	return str[0].toUpperCase() + str.slice(1)
}

export { date, time, dateTime, number, properCase }
